import {createModelFactory, RestClient} from "@juis/model";

/** One transport for the whole application, and the model factory bound to it. */
export const client = new RestClient();
export const defineModel = createModelFactory(client);
